import ProfileTab from "../components/profileTab/profileTab";
import Main from "../components/content/Main";

function App() {
  return (
    <>
      <div className="overflow-x-hidden h-fit w-full flex lg:flex-row flex-col text-black border-b-black/10 border-b-2 font-medium tracking-[2px] leading-20">
        <ProfileTab />
        <Main></Main>
      </div>
      <div className="w-full h-0 mb-[20vh] flex justify-end">
        <a
          href="#project-section"
          className="relative w-fit top-4 right-8 text-black/60 dark:text-pale/60 hover:text-black/80"
        >
          Back To Top
        </a>
      </div>
    </>
  );
}

export default App;
